import { useState } from 'react';

export const usePagination = <T>(data: T[], itemsPerPage: number) => {
  const [currentPage, setCurrentPage] = useState(1);
  const maxPage = Math.ceil(data.length / itemsPerPage);

  const jump = (page: number) => {
    if (page >= 1 && page <= maxPage) {
      setCurrentPage(page);
    }
  };

  const currentData = () => {
    const begin = (currentPage - 1) * itemsPerPage;
    const end = begin + itemsPerPage;
    return data.slice(begin, end);
  };

  return { currentData, jump, maxPage, currentPage };
};
